import React, { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { DataContext } from "../../Context/Context";

const useStyles = makeStyles(() => ({
  deleteEntry: {
    color: "red",
  },
}));

export default function ContextMenu() {
  const classes = useStyles();
  const {
    entries,
    setEntries,
    setOpenEntryModal,
    contextMenu,
    setContextMenu,
    addNewItem,
    setAddNewItem,
  } = useContext(DataContext);

  const handleCloseContextMenu = () => {
    setContextMenu(null);
  };

  const handleDuplicate = () => {
    setContextMenu(null);
    setOpenEntryModal(true);
  };

  const handleCreateNew = () => {
    setContextMenu(null);

    setAddNewItem({
      id: "",
      type: "",
      category: "",
      amount: "",
      date: "",
      desc: "",
    });
    setOpenEntryModal(true);
  };

  const handleDelete = () => {
    const isConfirmed = window.confirm(
      "Are you sure you want to delete this entry?"
    );
    if (!isConfirmed) return;

    const filteredEntries = entries.filter((e) => e.id !== addNewItem.id);

    localStorage.setItem("entries", JSON.stringify(filteredEntries));
    setEntries(filteredEntries);
    setContextMenu(null);
  };

  return (
    <div>
      <Menu
        open={contextMenu !== null}
        onClose={handleCloseContextMenu}
        anchorReference="anchorPosition"
        anchorPosition={
          contextMenu !== null
            ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
            : undefined
        }
      >
        <MenuItem onClick={handleDuplicate}>Duplicate</MenuItem>
        <MenuItem onClick={handleCreateNew}>Create New</MenuItem>
        <MenuItem className={classes.deleteEntry} onClick={handleDelete}>
          Delete
        </MenuItem>
      </Menu>
    </div>
  );
}
